// web/src/features/profile/hooks/useDeleteFamilyContact.ts
//
// DELETE mutation for removing a family contact. Invalidates the player's
// family cache on success. Web port of the mobile hook.
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { familyScopeKey } from '@sportninja/common/services/player/familyScope'
import {
  deleteFamilyContact,
  type DeleteFamilyContactInput,
  type DeleteFamilyContactResponse,
} from '@sportninja/common/services/player/deleteFamilyContact'

export const useDeleteFamilyContact = () => {
  const queryClient = useQueryClient()
  return useMutation<
    DeleteFamilyContactResponse,
    Error,
    DeleteFamilyContactInput
  >({
    mutationFn: deleteFamilyContact,
    // Override the global mutations.retry=1 default (see queryClient config).
    retry: 0,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.playerFamily.byPlayer(
          variables.playerId,
          familyScopeKey(variables.scope)
        ),
      })
    },
  })
}
